// pressKitConfig.js
// All editable data (contacts, videos, factSheet, logos) is now driven by cms.json.
// Press images are auto-generated from public/images/presskit/ by the CMS server.

import GENERATED_PRESS_IMAGES_DATA from "../generatedPressImagesData";
import CMS from "../cms.json";

const pk = CMS["presskit"] || {};

const PRESS_KIT_CONFIG = {
  // Leading slash matters: these render on /presskit, so a relative path
  // resolves against the current URL instead of the site root and 404s.
  folders: {
    logos: "/images/logos/",
    pressImages: "/images/presskit/",
    // Compressed derivatives used for on-page display; pressImages above holds
    // the full-resolution originals, served only when a file is downloaded.
    pressImagesDisplay: "/images/presskit-display/",
  },

  logos: CMS["presskit-logos"] || [],

  pressImages: GENERATED_PRESS_IMAGES_DATA.pressImages,

  pageTitle: pk.pageTitle || "Digital Presskit",

  pageSubtitle: pk.pageSubtitle || "",

  videos: pk.videos || [],

  heroVideo: pk.heroVideo || "",

  contacts: pk.contacts || {
    press: "",
    booking: "",
    management: "",
  },

  bios: pk.bios || [],

  metadata: pk.metadata || {
    bandName: "The Creaks",
    zipFileName: "The_Creaks_Press_Kit.zip",
    logoFolderName: "The_Creaks_Logos",
    imagesFolderName: "The_Creaks_Press_Images",
  },

  factSheet: pk.factSheet || { en: { items: [] }, cz: { items: [] } },
};

export const getPressKitData = () => {
  const logosWithUrls = PRESS_KIT_CONFIG.logos.map((logo) => ({
    ...logo,
    url: `${PRESS_KIT_CONFIG.folders.logos}${logo.filename}`,
    downloadFilename: `${PRESS_KIT_CONFIG.metadata.bandName}_Logo_${logo.name}.png`,
  }));

  const pressImagesWithUrls = PRESS_KIT_CONFIG.pressImages.map((image) => ({
    ...image,
    // Compressed version for the gallery/grid.
    url: `${PRESS_KIT_CONFIG.folders.pressImagesDisplay}${image.displayFilename || image.filename}`,
    // Full-resolution original, used only for downloads.
    downloadUrl: `${PRESS_KIT_CONFIG.folders.pressImages}${image.filename}`,
    downloadFilename: `${PRESS_KIT_CONFIG.metadata.bandName}_${image.category}_${image.id}.jpg`,
  }));

  return {
    logos: logosWithUrls,
    pressImages: pressImagesWithUrls,
    pageTitle: PRESS_KIT_CONFIG.pageTitle,
    pageSubtitle:
      PRESS_KIT_CONFIG.pageSubtitle ||
      `Everything you need to feature ${PRESS_KIT_CONFIG.metadata.bandName}`,
    bios: PRESS_KIT_CONFIG.bios,
    videos: PRESS_KIT_CONFIG.videos,
    heroVideo: PRESS_KIT_CONFIG.heroVideo,
    factSheet: PRESS_KIT_CONFIG.factSheet,
    contacts: PRESS_KIT_CONFIG.contacts,
    metadata: PRESS_KIT_CONFIG.metadata,
    folders: PRESS_KIT_CONFIG.folders,
  };
};

export const getImagesByCategory = (category) => {
  const { pressImages } = getPressKitData();
  return pressImages.filter((image) => image.category === category);
};

export const getAvailableCategories = () => {
  const { pressImages } = getPressKitData();
  const allCategories = pressImages.map((image) => image.category);
  return [...new Set(allCategories.length > 0 ? allCategories : ["General"])];
};

export const addNewImage = (imageData) => {
  const { pressImages } = getPressKitData();
  const newId = (pressImages.length > 0 ? Math.max(...pressImages.map((img) => img.id)) : 0) + 1;
  return { id: newId, ...imageData };
};

export default PRESS_KIT_CONFIG;
